export default __webpack_public_path__ + "static/filtered-bottom-62e8433629ffa2f75720df3bc9191a60.png";